import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
const logos = [{
  name: 'A.H. Belo Corporation',
  src: 'https://cdn.magicpatterns.com/uploads/hVC67qyXaYrYygyAGLuNTb/A.H._Belo_Corp_logo.webp',
  className: ''
}, {
  name: 'Bessemer Venture Partners',
  src: 'https://cdn.magicpatterns.com/uploads/54Sm1gZCnjUVDsUrBJ6jb5/Bessemer_Logo.jpg',
  className: ''
}, {
  name: 'Spire Capital Partners',
  src: 'https://cdn.magicpatterns.com/uploads/nmc96bvUfmDxcBDeeaYZqN/spire_capital_partners_lp__logo.jpg',
  className: ''
}, {
  name: 'Veraction',
  src: 'https://cdn.magicpatterns.com/uploads/uD5JiLDVWqQ7BvZLPebRUh/logo_veraction.5aaac582dd469.png.png',
  className: ''
}, {
  name: 'Alert Logic',
  src: 'https://cdn.magicpatterns.com/uploads/sCVxLrzgXR1HR1FGdiwZsw/Alert-Logic-Logo-2020.png',
  className: ''
}, {
  name: 'Datical',
  src: 'https://cdn.magicpatterns.com/uploads/84toPwQA2c7eamiVtdWdwj/Datical-Logo.png',
  className: ''
}, {
  name: 'MGT',
  src: 'https://cdn.magicpatterns.com/uploads/8FXs35XPLH3u44hJbxmJL4/images-1.png',
  className: 'max-h-[10px] max-w-[80px]'
}, {
  name: 'DISCO',
  src: 'https://cdn.magicpatterns.com/uploads/hn3xDnbxLfCjf6o1MucPgG/images.png',
  className: ''
}, {
  name: 'The Linux Foundation',
  src: 'https://cdn.magicpatterns.com/uploads/cCHm4uTZhhHMs1HFFEWpSV/The-Linux-Foundation-768x253-1.png',
  className: ''
}, {
  name: 'Vital Farms',
  src: 'https://cdn.magicpatterns.com/uploads/gGZo7poNcw9wudak2TEMX9/Vital_Farms_Logo.jpg',
  className: ''
}, {
  name: 'Zilliant',
  src: 'https://cdn.magicpatterns.com/uploads/kUaLtt1JWFcYGvtQfivTcE/ZL-Logo-RGB.png',
  className: ''
}, {
  name: 'Susquehanna Growth Equity',
  src: 'https://cdn.magicpatterns.com/uploads/wgeDmYQdXjFBBctK71fJh6/64e65c60aa87c3f03881bb06_sgeplogo_long2-1.webp',
  className: ''
}, {
  name: 'Summit Partners',
  src: 'https://cdn.magicpatterns.com/uploads/gg2ShM5UE5dZfdjzWxo1Wi/Summit_Partners_Logo.svg.png',
  className: ''
}, {
  name: 'Transition Capital Partners',
  src: 'https://cdn.magicpatterns.com/uploads/1MJMyb1qSSa5KappknT7WN/Transition-Capital-Partners-logo-blue.png',
  className: ''
}];
function shuffle<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
// Double the logos for seamless infinite scroll
const duplicatedLogos = [...logos, ...logos];
export function TrustedBy() {
  const shuffledLogos = useMemo(() => {
    const randomized = shuffle(logos);
    return [...randomized, ...randomized];
  }, []);
  return <section className="pt-16 pb-24 bg-white border-b border-gray-100" data-id="element-118">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <motion.h3 initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-sm font-bold text-gray-400 uppercase tracking-widest text-center mb-12" data-id="element-120">
          Trusted by Leading Tech Companies
        </motion.h3>
      </div>

      {/* Carousel container */}
      <div className="relative overflow-hidden" data-id="element-121">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10" data-id="element-122" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10" data-id="element-123" />

        <motion.div className="flex items-center gap-20" animate={{
        x: ['0%', '-50%']
      }} transition={{
        x: {
          repeat: Infinity,
          repeatType: 'loop',
          duration: 20,
          ease: 'linear'
        }
      }} data-id="element-124">
          {shuffledLogos.map((logo, index) => <div key={`${logo.name}-${index}`} className="flex-shrink-0 flex items-center justify-center h-16 w-48 grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-125">
              <img src={logo.src} alt={logo.name} className={`max-h-full max-w-full object-contain ${logo.className}`} data-id="element-126" />
            </div>)}
        </motion.div>
      </div>
    </section>;
}